import React, { useContext } from "react";
import styles from './QuoteNavigation.module.css';
import { NavLink } from "react-router-dom";
import { BrandCountryContext } from "../providers/BrandCountryProvider";

export default function HiQQuoteNavigation({currSection,setCurrSection}){

    const handleNavClick = () => {
        window.scrollTo(0,0);
    }

    return(
        <div className={`${styles.navTabBar} ${styles.hiq}`} style={{display: `${currSection === 'Submitted' || currSection === 'Failed'? 'none' : 'grid'}`}}>
            <div onClick={() => setCurrSection('Quote Basket')} className={`${styles.tab} ${currSection === 'Quote Basket' || currSection === 'Delivery Details' || currSection === 'Overview'? styles.selected : ''} ${currSection === 'Quote Basket'? styles.selectedAb : ''}`}> 
                <div>Quote Basket</div>
                <div className={styles.lowerContainer}>
                    <div></div>
                    <div className={styles.roundel}>1</div>
                    <div className={`${styles.line} ${styles.right} ${currSection === 'Delivery Details' || currSection === 'Overview'? styles.selected : ''}`}></div>
                </div>
            </div>
            <div onClick={() => setCurrSection('Delivery Details')} className={`${styles.tab} ${currSection === 'Delivery Details' || currSection === 'Overview'? styles.selected : ''} ${currSection === 'Delivery Details'? styles.selectedAb : ''}`}> 
                <div>Delivery Details</div>
                <div className={styles.lowerContainer}>
                    <div className={`${styles.line} ${styles.left} ${currSection === 'Delivery Details' || currSection === 'Overview'? styles.selected : ''}`}></div>
                    <div className={styles.roundel}>2</div>
                    <div className={`${styles.line} ${styles.right} ${currSection === 'Overview'? styles.selected : ''}`}></div>
                </div>
            </div>
            <div onClick={() => setCurrSection('Overview')} className={`${styles.tab} ${currSection === 'Overview'? styles.selected : ''} ${currSection === 'Overview'? styles.selectedAb : ''}`}> 
                <div>Overview & Submit</div>
                <div className={styles.lowerContainer}>
                    <div className={`${styles.line} ${styles.left} ${currSection === 'Overview'? styles.selected : ''}`}></div>
                    <div className={styles.roundel}>3</div>
                    <div></div>
                </div>
            </div>
        </div>
    )
}